import * as types from '../constants'
import Api from '../services/api.js'

export function getLibraryControlsRequest(){
  return {
    type: types.GET_LIBRARY_CONTROLS_REQUEST,
  }
}

export function getLibraryControlsSuccess(body){
  return {
    type: types.GET_LIBRARY_CONTROLS_SUCCESS,
    body: body,
  }
}

export function getLibraryControlsFailure(exception){
  return {
    type: types.GET_LIBRARY_CONTROLS_FAILURE,
    exception: exception
  }
}

export function getLibraryControls(options) {
  return dispatch => {
    dispatch(getLibraryControlsRequest())
    const api = new Api();
    return api.get("/__api/v1/library_controls", { params: options })
      .then(response => {
          dispatch(getLibraryControlsSuccess(response.data))
      })
      .catch(err => dispatch(getLibraryControlsFailure(err)));
  }
}


export function createLibraryControlRequest(){
  return {
    type: types.CREATE_LIBRARY_CONTROL_REQUEST,
  }
}

export function createLibraryControlSuccess(body){
  return {
    type: types.CREATE_LIBRARY_CONTROL_SUCCESS,
    body: body,
  }
}

export function createLibraryControlFailure(exception){
  return {
    type: types.CREATE_LIBRARY_CONTROL_FAILURE,
    exception: exception
  }
}

export function createLibraryControl(control) {
  return dispatch => {
    dispatch(createLibraryControlRequest())
    const api = new Api();
    return api.post("/__api/v1/library_controls", control)
      .then(response => {
        dispatch(createLibraryControlSuccess(response.data))
      })
      .catch(err => dispatch(createLibraryControlFailure(err)));
  }
}

export function updateLibraryControlRequest(){
  return {
    type: types.UPDATE_LIBRARY_CONTROL_REQUEST,
  }
}

export function updateLibraryControlSuccess(body){
  return {
    type: types.UPDATE_LIBRARY_CONTROL_SUCCESS,
    body: body,
  }
}

export function updateLibraryControlFailure(exception){
  return {
    type: types.UPDATE_LIBRARY_CONTROL_FAILURE,
    exception: exception
  }
}

export function updateLibraryControl(control) {
  return dispatch => {
    dispatch(updateLibraryControlRequest())
    const api = new Api();
    return api.put("/__api/v1/library_controls/" + control.id, control)
      .then(response => {
        dispatch(updateLibraryControlSuccess(response.data))
      })
      .catch(err => dispatch(updateLibraryControlFailure(err)));
  }
}

export function archiveLibraryControlRequest(){
  return {
    type: types.ARCHIVE_LIBRARY_CONTROL_REQUEST,
  }
}

export function archiveLibraryControlSuccess(body){
  return {
    type: types.ARCHIVE_LIBRARY_CONTROL_SUCCESS,
    body: body,
  }
}

export function archiveLibraryControlFailure(exception){
  return {
    type: types.ARCHIVE_LIBRARY_CONTROL_FAILURE,
    exception: exception
  }
}

export function archiveLibraryControl(control_id) {
  return dispatch => {
    dispatch(archiveLibraryControlRequest())
    const api = new Api();
    return api.put("/__api/v1/library_controls/" + control_id + "/archive")
      .then(response => {
        dispatch(archiveLibraryControlSuccess(response.data))
      })
      .catch(err => dispatch(archiveLibraryControlFailure(err)));
  }
}

export function unarchiveLibraryControlRequest(){
  return {
    type: types.UNARCHIVE_LIBRARY_CONTROL_REQUEST,
  }
}

export function unarchiveLibraryControlSuccess(body){
  return {
    type: types.UNARCHIVE_LIBRARY_CONTROL_SUCCESS,
    body: body,
  }
}

export function unarchiveLibraryControlFailure(exception){
  return {
    type: types.UNARCHIVE_LIBRARY_CONTROL_FAILURE,
    exception: exception
  }
}

export function unarchiveLibraryControl(control_id) {
  return dispatch => {
    dispatch(unarchiveLibraryControlRequest())
    const api = new Api();
    return api.put("/__api/v1/library_controls/" + control_id + "/unarchive")
      .then(response => {
        dispatch(unarchiveLibraryControlSuccess(response.data))
      })
      .catch(err => dispatch(unarchiveLibraryControlFailure(err)));
  }
}


export function getControlOwnersRequest(){
  return {
    type: types.GET_CONTROL_OWNERS_REQUEST,
  }
}

export function getControlOwnersSuccess(body){
  return {
    type: types.GET_CONTROL_OWNERS_SUCCESS,
    body: body,
  }
}

export function getControlOwnersFailure(exception){
  return {
    type: types.GET_CONTROL_OWNERS_FAILURE,
    exception: exception
  }
}

export function getControlOwners() {
  return dispatch => {
    dispatch(getControlOwnersRequest())
    const api = new Api();
    return api.get("/__api/v1/library_controls/control_tags", { params: { context: "owners" } })
      .then(response => {
          dispatch(getControlOwnersSuccess(response.data))
      })
      .catch(err => dispatch(getControlOwnersFailure(err)));
  }
}


export function getControlTagsRequest(){
  return {
    type: types.GET_CONTROL_TAGS_REQUEST,
  }
}

export function getControlTagsSuccess(body){
  return {
    type: types.GET_CONTROL_TAGS_SUCCESS,
    body: body,
  }
}

export function getControlTagsFailure(exception){
  return {
    type: types.GET_CONTROL_TAGS_FAILURE,
    exception: exception
  }
}

export function getControlTags() {
  return dispatch => {
    dispatch(getControlTagsRequest())
    const api = new Api();
    return api.get("/__api/v1/library_controls/control_tags", { params: { context: "tags" } })
      .then(response => {
          dispatch(getControlTagsSuccess(response.data))
      })
      .catch(err => dispatch(getControlTagsFailure(err)));
  }
}

export function showTranslationModal(translation_id) {
  return { type: types.SHOW_TRANSLATION_MODAL, translation_id}
}

export function hideTranslationModal() {
  return { type: types.HIDE_TRANSLATION_MODAL}
}

export function pendingLibraryControlTranslation(library_control){
  return {
    type: types.PENDING_LIBRARY_CONTROL_TRANSLATION,
    library_control,
  }
}

export function completedLibraryControlTranslation(library_control, language){
  return {
    type: types.COMPLETED_LIBRARY_CONTROL_TRANSLATION,
    library_control,
    language
  }
}

export function failedLibraryControlTranslation(library_control){
  return {
    type: types.FAILED_LIBRARY_CONTROL_TRANSLATION,
    library_control,
  }
}



// WEBPACK FOOTER //
// ./src/actions/library_control.js